/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { sandboxDownloadFile } from "../../funcs/sandboxDownloadFile.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DownloadWorkspaceFileRequest$inboundSchema,
};

export const tool$sandboxDownloadFile: ToolDefinition<typeof args> = {
  name: "sandbox-download-file",
  description: `Download Workspace File

Download raw bytes from a file in the session workspace.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await sandboxDownloadFile(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
